<template>
  <div class="scrollable">
    <v-layout v-if="loading" row justify-center align-center>
      <v-progress-circular :size="70" class="mt-10" :width="7" color="primary" indeterminate></v-progress-circular>
    </v-layout>
    <h2>{{title}}</h2>
    <v-form ref="form" lazy-validation>
      <v-flex xs12>
        <v-autocomplete
          v-model="model"
          :items="internalLocations"
          :loading="isLoading"
          :search-input.sync="searchString"
          hide-no-data
          hide-selected
          item-text="name"
          item-value="locationId"
          :label="$translate('SEARCH')"
          clearable
          :placeholder="$translate('START_TYPING')"
          return-object
          @change="autocompleteChange"
        ></v-autocomplete>
      </v-flex>

      <h3>{{$translate('PART_OF')}}</h3>
      <v-text-field
        @click="loadLocations"
        v-model="appendedLocationsString"
        prepend-icon="chevron_left"
        @click:prepend="goBack"
        readonly
      ></v-text-field>
      <v-list v-if="showList" class="scrollList-partOf">
        <div v-for="(e, key, index) in partOfLocations" :key="index">
          <v-list-tile @click.capture.stop="doSomething(e)">
            <v-list-tile-action>
              <v-checkbox v-model="e.status"></v-checkbox>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{e.name}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </div>
      </v-list>

      <!-- <v-flex xs12> -->
      <v-layout align-center class="ml-1 mr-1">
        <!-- <v-flex> -->
        <v-tooltip bottom>
          <v-btn
            round
            slot="activator"
            class="mt-4"
            @click="removeFilters()"
            color="secondary"
          >{{$translate('DELETE_FILTERS')}}</v-btn>
          <span>Clear filter</span>
        </v-tooltip>
        <!-- </v-flex> -->
      </v-layout>
      <!-- </v-flex> -->
    </v-form>
  </div>
</template>

<script>
import ExpendableTags from "@/components/ExpendableTags";
// import * as parser from "../api/Parser";
import * as dssRequest from "../api/dssRequest";
import { mapGetters } from "vuex";
import appConfig from "../../config/app_config";
import LocationObject from "../objects/LocationObject";
import BaseObject from "../objects/BaseObject";

export default {
  name: "NavigationOverview",
  props: {
    properties: Object
  },
  computed: {
    ...mapGetters({
      filters: "getFilterTags",
      locations: "locationsModule/getLocations",
      _getFiltersLocation: "getFiltersLocation"
    })
  },
  components: {
    ExpendableTags
  },
  watch: {
    searchString: function(e, prev) {
      // if(prev !== null && e === null){
      //   this.searchString = prev;
      // }
      this.$store.commit("setFilterName", this.searchString);
      this.isLoading = true;
      this.getLocationInternally();
    },
    appendedLocationsString: function(newV, oldV) {
      this.addFilter();
    }
  },
  data() {
    return {
      preselection: [],
      title: this.$translate("LOCATION_OVERVIEW"),
      expTagProp: {},
      disableExpTag: false,
      model: {},
      isLoading: false,
      rootLocation: [],
      showList: false,
      appendedLocations: [],
      appendedLocationsString: "",
      partOfSelected: [],
      partOfLocations: [],
      loadingButton: false,
      loading: false,
      lastSearch: "",
      searchString: "",
      internalLocations: []
    };
  },
  mounted() {
    this.removeFilters();
  },
  created() {

    window.EventBus.listen("functionStatus", this.functionStatus);

    if (
      this._getFiltersLocation !== undefined &&
      !_.isEmpty(this._getFiltersLocation)
    ) {
      this.appendedLocations = this._getFiltersLocation.appendedLocations;
      this.appendedLocationsString = this._getFiltersLocation.appendedLocationsString;
      this.partOfLocations = this._getFiltersLocation.partOfLocations;
      this.searchString = this._getFiltersLocation.searchString;
      // the root location won't be loaded
    } else {
      this.getRootLocations();
    }

    if (
      !_.isEmpty(this.properties.params) &&
      !_.isEmpty(this.properties.params) &&
      this.properties.params.reload === true
    ) {

      this.getPartOfLocation(
        this.appendedLocations[this.appendedLocations.length - 1]
      );
    }
  },
  beforeDestroy() {
    window.EventBus.removeListener("functionStatus", this.functionStatus);
  },
  methods: {
    setSelectedTags(data) {
      this.$store.commit("setStatusTags", data);
    },
    autocompleteChange(e) {

      this.$store.commit("setFilterName", e != undefined ? e.name : "");
      window.EventBus.fire("getLocations", {});
    },
    removeFilters() {
      this.appendedLocationsString = "";
      this.appendedLocations = [];
      this.partOfLocations = [];
      this.rootLocation = [];
      this.searchString = "";
      this.$store.commit("setFilterName", "");
      this.$store.commit("setFiltersLocation", {});
      this.$store.commit("setStatusTags", null);
      this.preselection = [];
      this.getRootLocations();
      window.EventBus.fire("getLocations", {});
    },
    getLocationInternally() {
      const payload = {
        Name: this.searchString,
        PartnerId: this.$store.getters['auth/partnerId'],
        FunctionId: 'LocationFunctionLibrary::getLocationsV2',
      };
      dssRequest.doRequest(
        response => {
          console.log("The generic call 'getLocationsV2' on - NavigationOverview.vue - was successful", response);
          if (!response.data.hasOwnProperty('Locations')) {
            // window.EventBus.fire("triggerGenericErrorDialog", 'W_GL_001');
            return;
          }
          if (response.data.Locations !== undefined) {
            this.internalLocations = LocationObject._createArrayWithObjects(
              response.data.Locations
            );
          }
          console.log("this.internalLocations", this.internalLocations);
          this.isLoading = false;
        },
        error => {
          console.log("The generic call 'getLocationsV2' on - NavigationOverview.vue - was not successful", error);
          this.isLoading = false;
          // window.EventBus.fire("triggerGenericErrorDialog", 'W_GL_001');
        },
        "communicateWithDBLibrary",
        appConfig.dss.locationMgr,
        payload,
        600000,
        false
      );
    },
    /*
     it asks directly for the location because the ones available globally can be already filtered out
     */
    getRootLocations() {
      const payload = {
        LocationId: "root",
        FunctionId: "LocationFunctionLibrary::getDirectChildrenLocations"
        };
      dssRequest.doRequest(
        response => {
          console.log("The generic call getDirectChildrenLocations was successful", response);
          if (response.data.Children != undefined) {
            const tmpLocations = BaseObject._toLowerCaseInitialProperty(
              BaseObject._createArrayWithObjects(response.data.Children)
            );
            tmpLocations.forEach(i => {
              this.rootLocation.push(JSON.parse(JSON.stringify(i)));
              this.partOfLocations.push(JSON.parse(JSON.stringify(i)));
            });
          }
        },
        error => {
          console.log("The generic call getDirectChildrenLocations was not successful", error);
        },
        "communicateWithDBLibrary",
        appConfig.dss.locationMgr,
        payload
      );
    },
    goBack() {
      let last = this.appendedLocations.pop();
      this.setPartOfString();
      if (this.appendedLocations.length == 0) {
        this.partOfLocations = [];
        this.rootLocation.forEach(e => {
          e.status = false;
          this.partOfLocations.push(e);
        });
      } else {
        this.getPartOfLocation(
          this.appendedLocations[this.appendedLocations.length - 1]
        );
      }
    },
    loadLocations() {
      this.showList = true;
    },
    doSomething(p) {
      p.status = !p.status;
      if (p.status) {
        this.appendedLocations.push(p);
      } else {
        let i = this.appendedLocations.indexOf(p);
        this.appendedLocations.splice(i, 1);
      }
      this.setPartOfString();
      this.getPartOfLocation(p);
    },
    setPartOfString() {
      this.appendedLocationsString = this.appendedLocations
        .map(i => i.name)
        .join(" > ");
    },
    addFilter() {
      let partOfLocation = this.appendedLocations[
        this.appendedLocations.length - 1
      ];
      this.loadingButton = !this.loadingButton;
      let filterObject = { filters: {} };
      if (partOfLocation !== undefined)
        filterObject.filters.partOf = partOfLocation;

      filterObject.appendedLocations = this.appendedLocations;
      filterObject.appendedLocationsString = this.appendedLocationsString;
      filterObject.partOfLocations = this.partOfLocations;
      filterObject.searchString = this.searchString;

      this.$store.commit("setFiltersLocation", filterObject);
      window.EventBus.fire("getLocations", filterObject);

      this.$store.commit("setSelectedPartOfLocation", partOfLocation);
    },
    searchLocation2() {
    },
    searchLocation() {
      this.$store.commit("setFilterName", this.searchString);
    },
    functionStatus(obj) {
      this.loadingButton = false;
    },
    getPartOfLocation(location) {
      if (location === undefined) return;

      const payload = {
        LocationId: location.locationId,
        StructuredReply: true,
        FunctionId: "LocationFunctionLibrary::getDirectChildrenLocations"
      };
      dssRequest.doRequest(
        response => {
          console.log("The generic call getDirectChildrenLocations was successful", response);
          const children = LocationObject._createArrayWithObjects(response.data.Children);
          this.partOfLocations = [];
          children.forEach(e => {
            e.status = false;
            this.partOfLocations.push(e);
          });
        },
        error => {
          console.log("The generic call getDirectChildrenLocations was not successful", error);
        },
        "communicateWithDBLibrary",
        appConfig.dss.locationMgr,
        payload
      );
    }
  }
};
</script>

<style scoped lang="scss">
.scrollList-partOf {
  width: 100%;
  max-height: 220px !important;
  overflow-x: hidden;
  overflow-y: auto;
}

.v-progress-circular {
  margin: 1rem;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
